import { Injectable } from '@angular/core';
import { PasswordCheckResult, PasswordInvalidReason } from './password-check-result';
import { FormControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  constructor() {}

  public checkPassword(password: unknown): PasswordCheckResult {
    if (typeof password !== 'string') {
      return {
        valid: false,
        reasons: [PasswordInvalidReason.MinimumLength],
      };
    }

    const validations: { regex: RegExp; reason: PasswordInvalidReason }[] = [
      { regex: /[A-Z]/, reason: PasswordInvalidReason.CapitalLetterRequired },
      { regex: /\d/, reason: PasswordInvalidReason.NumberRequired },
      { regex: /[^0-9a-zA-Z]/, reason: PasswordInvalidReason.SpecialCharRequired },
      { regex: /.{8,}/, reason: PasswordInvalidReason.MinimumLength },
    ];

    const result: PasswordCheckResult = {
      valid: true,
      reasons: [],
    };

    for (const validation of validations) {
      if (!validation.regex.test(password)) {
        result.valid = false;
        result.reasons.push(validation.reason);
      }
    }

    return result;
  }

  public getMessage() {
    return 'Password must include a capital letter, a number, a special character, and be at least 8 characters long.';
  }

  public checkPasswordValidator(control: FormControl): ValidationErrors | null {
    const result = this.checkPassword(control.value);

    if (result.valid) {
      return null;
    } else {
      return { password: this.getMessage() };
    }
  }
}
